import React from 'react';
import PaginationBase from '../../../common/base/PaginationBase';
import { PAGINATION, FILTER } from '../../../common/types/paginationType';
import global from '../../../common/utility/global';
import Header from '../../../components/Header';
import Filters from './Filters';
import GeneralTable from './GeneralTable';
import ResumenTable from './ResumenTable';
import DetalladoEstablecimientoTable from './DetalladoEstablecimientoTable';

import establecimientoService from '../../../service/administracion/establecimientoService';
import productoService from '../../../service/administracion/productoService';
import almacenService from '../../../service/administracion/almacenService';
import reporteGeneralService from '../../../service/logistica/reporteGeneralService';
export default class Index extends PaginationBase {
    constructor(props) {
        super(props);
        this.props.onSetBreadcrumb();
        this.state = {
            establecimientos: [{ id: -1, nombre: "SELECCIONAR ESTABLECIMIENTO" }],
            almacenes: [],
            monedas: [],
            productos: [],
            productosAutocomplete: [],
            almacenesLoading: false,
            productosLoading: false,
            establecimientosLoading: false,
            monedasLoading: false,
            showGeneral: true,
            loadingExcel:false,
            showResumen: false,
            showDetallado: false,
            filter: {
                fechaDesdeFormat: global.fetchCurrentDateStr(true),
                fechaHastaFormat: global.fetchCurrentDateStr(),
                fechaFormat: global.fetchCurrentDateStr(),
                idEstablecimiento: 0,
                idAlmacen: 0,
                idProducto: 0,
                tipoReporte: 1,
                incluirNotaVenta: true,
                referencia: ''
            },
            DataSource: [],
            pagination: PAGINATION,

        }
    }


    handleKeyUpInput = (e) => {
        e.preventDefault();
        if (e.keyCode === 13) {
            this.handleSearch();
        }
    };


    handleChange = async (property, value) => {

        const filter = { ...this.state.filter, [property]: value };
        this.setState({ filter });

        if (property === "idEstablecimiento") {
            this.setState({ almacenesLoading: true });
            const almacenes = await almacenService.listarPorIdEstablecimiento(value);
            this.setState({
                filter: { ...this.state.filter, idAlmacen: 0 },
                almacenes: almacenes ? almacenes : [],
                almacenesLoading: false
            });
        }
    };


    handleSearchAutocomplete = (value) => {
        try {
            const result = this.state.productos.filter(item => {
                return (item.nombre).toUpperCase().match(value.toUpperCase());
            }).slice(0, 75);
            this.setState({ productosAutocomplete: result });
        } catch (error) {
            console.log(error);
        }
    };

    handleChangeAutocomplete = (value) => {
        this.setState({
            filter: {
                ...this.state.filter,
                idProducto: value.key
            }
        });
    };

    handleClearAutocomplete = () => {
        this.setState({
            filter: {
                ...this.state.filter,
                idProducto: 0
            }
        });
    }

    handleClearFilters = () => {
        var filter = {
            idEstablecimiento: 0,
            idAlmacen: 0,
            idProducto: 0,
            tipoReporte: 1,
            fechaDesdeFormat: global.fetchCurrentDateStr(true),
            fechaHastaFormat: global.fetchCurrentDateStr(),
            fechaFormat: global.fetchCurrentDateStr(),
            incluirNotaVenta: true,
            referencia: ''
        };
        this.setState({
            filter,
            DataSource: []
        });
    };

    handleSearch = async () => {


        var dataSource = [];
        if (this.state.filter.tipoReporte === 1) {
            dataSource = await reporteGeneralService.general(this.state.filter);
            this.setState({
                pagination: dataSource ? dataSource : [],
                showGeneral: true,
                showResumen: false,
                showDetallado: false
            });
        } else if (this.state.filter.tipoReporte === 2) {
            dataSource = await reporteGeneralService.resumen(this.state.filter);
            this.setState({
                pagination: dataSource ? dataSource : [],
                showGeneral: false,
                showResumen: true,
                showDetallado: false
            });
        } else if (this.state.filter.tipoReporte === 3) {
            const dataSource = await reporteGeneralService.detalladoEstablecimientoAlmacen(this.state.filter);
            this.setState({
                DataSource: dataSource ? dataSource : [],
                showGeneral: false,
                showResumen: false,
                showDetallado: true
            });
        }
    }

    handleExportExcelGeneral = async () => {
        this.setState({ loadingPdf: true });
        var response = await reporteGeneralService.excelGeneral(this.state.filter);
        this.setState({ loadingPdf: false });
        if (response !== undefined)
            global.dowloadFile(response.data, "Reporte General.xlsx");
    }

    handleExportExcelResumen = async () => {
        this.setState({ loadingPdf: true });
        var response = await reporteGeneralService.excelResumen(this.state.filter);
        this.setState({ loadingPdf: false });
        if (response !== undefined)
            global.dowloadFile(response.data, "Reporte General - Resumén.xlsx");
    }

    handleExportExcelDetallado = async () => {
        this.setState({ loadingPdf: true });
        var response = await reporteGeneralService.excelDetallado(this.state.filter);
        this.setState({ loadingPdf: false });
        if (response !== undefined)
            global.dowloadFile(response.data, "Reporte General - Detallado.xlsx");
    }


    handleSearchKardexEstablecimiento = async () => {
        const dataSource = await reporteGeneralService.DetalladoEstablecimientoTable(this.state.filter);
        this.setState({
            DataSource: dataSource ? dataSource : []
        });
    }

    handleSearchKardexProducto = async (item) => {

        var fecha = new Date();

        var filter = {
            idAlmacen: item.id,
            fechaDesdeFormat: this.state.filter.fechaDesdeFormat, //'01/01/' + fecha.getFullYear(),
            fechaHastaFormat: this.state.filter.fechaHastaFormat,//global.fetchCurrentDateStr(),
            idProducto: this.state.filter.idProducto,
            idMoneda: 1,
            referencia: this.state.filter.referencia,
            incluirNotaVenta: this.state.filter.incluirNotaVenta,
        }
        const productosKardex = await reporteGeneralService.detalladoProducto(filter);

        var dataSource = [];

        this.state.DataSource.forEach(element => {
            var item = { ...element };
            dataSource.push(item);
        });

        dataSource.forEach(establecimiento => {
            establecimiento.almacenes.forEach(almacen => {
                if (almacen.id === item.id) {
                    almacen.productos = productosKardex;
                }
            });
        });

        this.setState({ DataSource: dataSource });
    }

    handleSearchKardexMovimiento = async (item) => {
        debugger
        var fecha = new Date();
        var filter = {
            idAlmacen: item.idAlmacen,
            fechaDesdeFormat: this.state.filter.fechaDesdeFormat,// '01/01/' + fecha.getFullYear(),
            fechaHastaFormat: this.state.filter.fechaHastaFormat,//global.fetchCurrentDateStr(),
            idProducto: item.id,
            idMoneda: 1,
            referencia: this.state.filter.referencia,
            incluirNotaVenta: this.state.filter.incluirNotaVenta,
            lote:item.lote
        }

        const movimientosKardex = await reporteGeneralService.detalladoMovimiento(filter);

        var dataSource = [];

        this.state.DataSource.forEach(element => {
            var item = { ...element };
            dataSource.push(item);
        });

        dataSource.forEach(establecimiento => {
            establecimiento.almacenes.forEach(almacen => {
                if (almacen.id === item.idAlmacen) {
                    almacen.productos.forEach(producto => {
                        
                        if (producto.id === item.id && producto.lote === item.lote ) {
                            producto.movimientos = movimientosKardex;
                        }
                    });
                }
            });
        });

        this.setState({ DataSource: dataSource });
    }

    handleExportExcelDetallado = async () => {
        this.setState({ loadingExcel: true });
        var response = await reporteGeneralService.excelDetallado(this.state.filter);
        this.setState({ loadingExcel: false });
        if (response !== undefined)
            global.dowloadFile(response.data, "Reporte de Kardex Detallado.xlsx");
    }

    handleExportExcelResumido = async () => {
        this.setState({ loadingExcel: true });
        var response = await reporteGeneralService.excelResumido(this.state.filter);
        this.setState({ loadingExcel: false });
        if (response !== undefined)
            global.dowloadFile(response.data, "Reporte de Kardex Resumido.xlsx");
    }

    handleChangeResumen = async (pagination) => {

        var dataSource = [];
        const filter = { ...this.state.filter, ...pagination };
        this.setState({ filter });
        dataSource = await reporteGeneralService.resumen(filter);
        this.setState({
            pagination: dataSource ? dataSource : [],
            showGeneral: false,
            showResumen: true,
            showDetallado: false
        });
    };


    async componentDidMount() {
        this.setState({
            establecimientosLoading: true
        });
        const establecimientos = await establecimientoService.principales();
        const productos = [];// await productoService.listar();
        const productos_filter = productos.filter(m => m.idTipoProducto === 1);
        const dataSource = await reporteGeneralService.general(this.state.filter);

        this.setState({
            establecimientos: establecimientos ? establecimientos : [],
            productos: productos_filter ? productos_filter : [],
            establecimientosLoading: false,
            DataSource: dataSource.data,
            pagination: dataSource
        });
    }

    render() {

        return (
            <div>
                <Header
                    title="Inventario General"
                    onSearch={this.handleSearch}
                    onClearFilters={this.handleClearFilters}
                />
                <Filters
                    filter={this.state.filter}
                    establecimientos={this.state.establecimientos}
                    almacenes={this.state.almacenes}
                    monedas={this.state.monedas}
                    productos={this.state.productosAutocomplete}
                    establecimientosLoading={this.state.establecimientosLoading}
                    productosLoading={this.state.productosLoading}
                    almacenesLoading={this.state.almacenesLoading}
                    onSearchAutocomplete={this.handleSearchAutocomplete}
                    onChangeAutocomplete={this.handleChangeAutocomplete}
                    onClearAutocomplete={this.handleClearAutocomplete}
                    onKeyUpSearch={this.handleKeyUpInput}
                    onChange={this.handleChange}
                />

                {

                    this.state.showGeneral ?
                        (
                            <GeneralTable
                                dataSource={this.state.DataSource}
                                pagination={this.state.pagination}

                                onExportExcel={this.handleExportExcelGeneral}
                            />

                        ) : this.state.showResumen ?
                            (
                                <ResumenTable
                                    dataSource={this.state.DataSource}
                                    pagination={this.state.pagination}
                                    onExportExcel={this.handleExportExcelResumen}
                                    onChange={this.handleChangeResumen}
                                    loadingExcel={this.state.loadingExcel}

                                />

                            ) :
                            (
                                <DetalladoEstablecimientoTable
                                    dataSource={this.state.DataSource}
                                    onSearchKardexProducto={this.handleSearchKardexProducto}
                                    onSearchKardexMovimiento={this.handleSearchKardexMovimiento}
                                    onExportExcelDetallado={this.handleExportExcelDetallado}
                                    loadingExcel={this.state.loadingExcel}
                                // onExportExcelResumido={this.handleExportExcelResumido}
                                />

                            )
                }

            </div>
        );
    }
}